import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
// import Add from "./Add";
// import Edit from "./Edit";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  findAllReject,
  Status,
} from "../../../utils/apis/wallet_management/wallet_hisory/wallet_history";

import { Per_Page_Dropdown, users_type } from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import { Country, State } from "../../../utils/apis/common/index";
import { formatDate } from "../../../utils/common";
import Select from "react-select";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";

const Tables = () => {
  const { UnauthorizedLogOut, Select2Data, IMG_URL, usertype } =
    useContext(Context);

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [searchDateTo, setSearchDateTo] = useState("");
  const [searchDateFrom, setSearchDatefrom] = useState("");
  const handleAccept = async (data) => {
    try {
      const response = await Status(data.id, { status: 1 });
      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  const getDataAll = async () => {
    try {
      const response = await findAllReject(
        currentPage,
        perPage,
        search,
        searchDateFrom,
        searchDateTo,
      );

      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, modalShow, modalEditShow, currentPage]);

  // const StatusChange = async (id) => {
  //   const response = await Status(id);
  //   setChangeStatus(response);
  // };

  // const handleDeleteRecord = async () => {
  //   setModalDeleteShow(false);
  //   if (recordToDeleteId) {
  //     const response = await Delete(recordToDeleteId);
  //     setRecordToDeleteId(null);
  //     setChangeStatus(response);
  //   }
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleDateChange = (date) => {
    setSearchDateTo(date); // Update the state with the selected date
  };

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Wallet Reject"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <br></br>
                  <Form.Control
                    type="text"
                    placeholder="Name/email"
                    onChange={(e) => setSearch(e.target?.value)}
                    value={search}
                  />
                </Form.Group>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <Form.Label className="formlbb">From</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="From"
                    max="9999-12-31"
                    min="0001-01-01"
                    value={searchDateFrom}
                    onChange={(e) => {
                      const value = e.target?.value;

                      // extra safety (optional)
                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      setSearchDatefrom(value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <Form.Label className="formlbb">To</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="to"
                    min={searchDateFrom} // already good
                    max="9999-12-31" // ✅ restrict year to 4 digits
                    value={searchDateTo}
                    onChange={(e) => {
                      const value = e.target?.value;

                      // basic format safety
                      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return;

                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      handleDateChange(value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <Button
                  type="button"
                  className="search-btn"
                  onClick={getDataAll}>
                  Search
                </Button>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <Button
                  type="button"
                  className="reset-btn"
                  onClick={() => {
                    setSearch("");
                    setSearchDateTo("");
                    setSearchDatefrom("");
                    setReset(!reset);
                  }}>
                  Reset
                </Button>
              </div>
              {/* <div className=" col-12 mt-3">
                <div className="d-flex  align-items-center">
                  <div className="show me-2">
                    <p style={{ color: "white" }} className="show m-0">
                      Show
                    </p>
                  </div>
                  <div className="number me-2">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(e) => setperPage(e.target?.value)}
                    >
                      {option?.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="entries">
                    <p style={{ color: "white" }} className="show m-0">
                      entries
                    </p>
                  </div>

                  <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-6 col-sm-2 col-12">
                    <div className="sowing me-2 ms-5">
                      <p
                        style={{ color: "white" }}
                        className="show m-0"
                      >{`Showing ${Math.min(
                        (currentPage - 1) * perPage + 1
                      )} to ${Math.min(
                        currentPage * perPage,
                        data?.data?.total
                      )} of ${data?.data?.total} entries`}</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>AC No</th>
                      <th>IFSC Code</th>
                      <th>UPI Id</th>
                      <th>Points</th>
                      <th>Remark</th>
                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.data?.data?.length > 0 ? (
                      data.data.data.map((d, index) => {
                        return (
                          <tr>
                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                            {/* <td>{index + 1}</td> */}
                            <td>{d?.User?.name ?? "-"}</td>
                            <td>{d?.User?.email ?? "-"}</td>

                            <td>{d?.ac_no ?? "-"}</td>
                            <td>{d?.ifsc_code ?? "-"}</td>
                            <td>{d?.upi_id ?? "-"}</td>
                            <td>{d?.amount ?? "-"}</td>
                            <td>{d?.remark ?? "-"}</td>
                            <td>{d?.createdAt?.split("T")[0]}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                <CustomPaginate
                  currentPage={data?.data?.current_page}
                  totalPages={data?.data?.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Tables;
